export default __webpack_public_path__ + "static/media/jayNicoleFitLogo.13fc16f4.png";